import script from "./GameActManager.vue?vue&type=script&setup=true&lang=js"
export * from "./GameActManager.vue?vue&type=script&setup=true&lang=js"

import "./GameActManager.vue?vue&type=style&index=0&id=fa83ae08&lang=less"
import "./GameActManager.vue?vue&type=style&index=1&id=fa83ae08&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa83ae08"]])

export default __exports__